import { useState, useContext } from "preact/compat";
import { createPortal } from 'preact/compat';
import { GlobalContext } from "@/context/GlobalContext";
import LocationSelectorItem from "@/components/LocationSelectorItem";
import ChevronRight from "@/icons/chevron-right.svg";
import CloseIcon from "@/icons/CloseIcon";
import BackArrow from "@/icons/back-arrow.svg";
import { getStateName } from "@/Utils";
import useUpdateCheckout from "@/hooks/useUpdateCheckout";
import useAgeGate from "@/hooks/useAgeGate";

function LocationSelector() {
	const { updateCheckoutType } = useUpdateCheckout();
	const { setDutchieRetailerAndFulfillment } = useAgeGate();
	const retailers = dutchie.retailers;
	const target = document.querySelector(".site-header-top");
	const [step, setStep] = useState(1);
	const [stepState, setStepState] = useState("");
	const { locationSelectorOpen, setLocationSelectorOpen } = useContext(GlobalContext);

	let allStates = new Set();
	retailers.map((loc) => {
		if ( !loc.state || loc.hidden === true ) {
			return;
		}
		allStates.add(getStateName(loc.state));
	});
	allStates = Array.from(allStates);
	const filteredLocations = retailers.filter(
		(location) => getStateName(location.state) === stepState
	);

	function updateCheckoutCloseSidebar(type) {
		updateCheckoutType(type);
		setLocationSelectorOpen(false);
	}

	if (!target) {
		return null;
	}

	return createPortal(
		<div id="location-selector" className={`drawer drawer-left location-selector ${locationSelectorOpen ? "is-open" : ""}`}>
			<div className="drawer-content">
				<div className="drawer-header">
					<h2>
						{ step === 1 ? (
							<span>Select a State</span>
						) : step === 2 ? (
							<span>Select a Location</span>
						) : null }

						{ step === 1 ? (
							<button
								className="btn-reset"
								aria-label="Close Location Selector"
								onClick={() => setLocationSelectorOpen(false)}
							>
								<CloseIcon color="#FFF" />
							</button>
						) : step === 2 ? (
							<button aria-label="Back" className="btn-reset cp-age-gate-back-btn" onClick={() => setStep(1)}>
								<BackArrow />
							</button>
						) : null }
					</h2>
				</div>
				<div className="drawer-list">
				{ step === 1 ? (
					<div className="location-selector-step step-1">
						{allStates.map((stateName) => (
							<button
								key={stateName}
								onClick={() => {
									setStep(2);
									setStepState(stateName);
								}}
								className="btn-reset location-selector-item"
							>
								<h3>Shop {stateName}</h3>
								<ChevronRight />
							</button>
						))}
					</div>
				) : step === 2 ? (
					<div className="location-selector-step step-2">
						{filteredLocations.map((retailer) =>
							retailer.hidden !== true ? (
								<LocationSelectorItem
									retailer={retailer}
									key={retailer.id}
									onHandleChange={updateCheckoutCloseSidebar}
									setDutchieRetailerAndFulfillment={setDutchieRetailerAndFulfillment}
								/>
							) : null
						)}
					</div>
				) : null }
				</div>
			</div>
			<div className="drawer-backdrop" onClick={() => setLocationSelectorOpen(false)}></div>
		</div>,
		target
	);
}
export default LocationSelector;
